import React from "react";

/* ══ SVG Icons — KanAI-modulens standarduppsättning ══ */
const icons = {
  sparkle: (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
      <path d="M10 2l1.5 4.5L16 8l-4.5 1.5L10 14l-1.5-4.5L4 8l4.5-1.5z" />
      <path d="M18 10l1 3 3 1-3 1-1 3-1-3-3-1 3-1z" opacity="0.7" />
      <path d="M15 2l.6 1.8L17.4 4.4l-1.8.6L15 6.8l-.6-1.8-1.8-.6 1.8-.6z" opacity="0.5" />
    </svg>
  ),
  sparkleLg: (
    <svg viewBox="0 0 32 32" fill="currentColor" stroke="none">
      <path d="M14 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2z" />
      <path d="M24 14l1.2 3.8L29 19l-3.8 1.2L24 24l-1.2-3.8L19 19l3.8-1.2z" opacity="0.7" />
      <path d="M20 3l.8 2.5L23.3 6.3l-2.5.8L20 9.6l-.8-2.5-2.5-.8 2.5-.8z" opacity="0.5" />
    </svg>
  ),
  stop: (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true">
      <rect x="6" y="6" width="12" height="12" rx="2" />
    </svg>
  ),
  send: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m22 2-7 20-4-9-9-4Z" /><path d="m22 2-11 11" />
    </svg>
  ),
  upload: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17,8 12,3 7,8" /><line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  sidebar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="9" y1="3" x2="9" y2="21" />
    </svg>
  ),
  dbSync: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M3 5v6c0 1.66 4 3 9 3" />
      <path d="M3 11v6c0 1.66 4 3 9 3" />
      <path d="M21 12v3a3 3 0 0 1-3 3h-3" />
      <polyline points="18 21 15 18 18 15" />
    </svg>
  ),
  x: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 6 6 18" /><path d="m6 6 12 12" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  ),
  plus: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 5v14" /><path d="M5 12h14" />
    </svg>
  ),
  file: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
      <path d="M14 2v6h6" />
    </svg>
  ),
  clock: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><polyline points="12,6 12,12 16,14" />
    </svg>
  ),
  search: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="10" cy="10" r="7" /><line x1="15.5" y1="15.5" x2="21" y2="21" />
    </svg>
  ),
  chatLines: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 8h14M5 12h8" />
    </svg>
  ),
  pin: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M5 1l4 4-2 2 3 4-4-3-2 2-4-4z" /><line x1="3" y1="11" x2="5.5" y2="8.5" />
    </svg>
  ),
  starFilled: (
    <svg viewBox="0 0 14 14" fill="currentColor" stroke="none">
      <path d="M7 1l1.8 3.6L13 5.3l-3 2.9.7 4.1L7 10.3 3.3 12.3l.7-4.1-3-2.9 4.2-.7z" />
    </svg>
  ),
  starOutline: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 1l1.8 3.6L13 5.3l-3 2.9.7 4.1L7 10.3 3.3 12.3l.7-4.1-3-2.9 4.2-.7z" />
    </svg>
  ),
  moreDots: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="7" cy="3" r="0.8" /><circle cx="7" cy="7" r="0.8" /><circle cx="7" cy="11" r="0.8" />
    </svg>
  ),
  unreadCircle: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="7" cy="7" r="5" /><circle cx="7" cy="7" r="2" fill="currentColor" />
    </svg>
  ),
  edit: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M10 2l2 2-7 7H3v-2z" />
    </svg>
  ),
  copy: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="4" y="4" width="7" height="7" rx="1.5" />
      <path d="M4 10H3.5A1.5 1.5 0 012 8.5v-5A1.5 1.5 0 013.5 2h5A1.5 1.5 0 0110 3.5V4" />
    </svg>
  ),
  trash: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M2 4h10M5 4V2.5A.5.5 0 015.5 2h3a.5.5 0 01.5.5V4M4 4v7.5a1 1 0 001 1h4a1 1 0 001-1V4" />
    </svg>
  ),
  archiveBox: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 4h10l-.5 3H2.5z" />
      <path d="M3 7v4a1 1 0 001 1h6a1 1 0 001-1V7" />
      <path d="M6 9h2" />
    </svg>
  ),
  restore: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 7a5 5 0 1 0 1-3" />
      <path d="M2 2v4h4" />
    </svg>
  ),
  listView: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="3" y1="3.5" x2="11" y2="3.5" />
      <line x1="3" y1="7" x2="11" y2="7" />
      <line x1="3" y1="10.5" x2="11" y2="10.5" />
    </svg>
  ),
  gridView: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="2" y="2" width="4" height="4" rx="0.5" />
      <rect x="8" y="2" width="4" height="4" rx="0.5" />
      <rect x="2" y="8" width="4" height="4" rx="0.5" />
      <rect x="8" y="8" width="4" height="4" rx="0.5" />
    </svg>
  ),
  folderIcon: (
    <svg viewBox="0 0 16 16" fill="currentColor" stroke="none">
      <path d="M1.5 3A1.5 1.5 0 013 1.5h3.1a1.5 1.5 0 011.2.6L8.4 3.6a.5.5 0 00.4.2H13A1.5 1.5 0 0114.5 5.3v7.2A1.5 1.5 0 0113 14H3a1.5 1.5 0 01-1.5-1.5V3z" />
    </svg>
  ),
  folderPlus: (
    <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 3.5A1.5 1.5 0 013.5 2H5l1.2 1.5H10.5A1.5 1.5 0 0112 5v5.5A1.5 1.5 0 0110.5 12h-7A1.5 1.5 0 012 10.5V3.5z" />
      <path d="M7 7v3M5.5 8.5h3" />
    </svg>
  ),
  chevronRight: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 4l4 4-4 4" />
    </svg>
  ),
  docIcon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h10v12H4z" /><path d="M7 8h4M7 11h2" />
    </svg>
  ),
  chart: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 14l4-4 3 3 5-6" /><rect x="2" y="3" width="14" height="12" rx="2" />
    </svg>
  ),
  risk: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 2l2 5h5l-4 3.5 1.5 5L9 12.5 4.5 15.5 6 10.5 2 7h5z" />
    </svg>
  ),
};

export default icons;
